<template>
  <div class="ArticleDetailCom text-left" v-title :data-title="detail.typeName||'' + '详情'">
    <div v-if="loading" class="text-center">
      加载中...
    </div>
    <van-empty v-else-if="!detail || !detail.content"
      class="custom-image"
      :image="icon"
      description="没有内容哦~"
    />
    <template v-else>
      <div class="fs6 pt2 pb1 font-bold">
        {{detail.title}}
      </div>
      <div class="row align-items-center fc-less pt1 pb5 fs5 ">
        <template v-if="detail.author">
          <van-icon name="manager-o" />
          <div class="article-author pl1 pr7">{{detail.author}}</div>
        </template>
        <div class="pr7">{{(detail.updateTime || detail.createTime)}}</div>
        <div class="flex-1"></div>
        <!-- <template v-if="detail.readership">
          <van-icon name="eye-o" />
          <div class="pl1">{{(detail.readership || 0)}}</div>
        </template> -->
      </div>
      <div v-if="detail.content" class="article-content" v-html="detail.content"></div>
      <!-- <div class="row align-items-center pt5 fc-less">
        <div class="flex-1"></div>
        <template v-if="detail.readership">
          <van-icon name="eye-o" />
          <div class="pl1">{{(detail.readership || 0)}}</div>
        </template>
      </div> -->
    </template>
  </div>
</template>

<script>
import {
  sendRequest,
} from '@/network/NetworkAccessor';
import storage from '@/uitls/cacheUtil';
import config from '@/config';

export default {
  name: 'ArticleDetailCom',
  components: { },
  data() {
    return {
      loading: false,
      detail: {
        id: '',
        title: '',
        author: '',
        content: '',
        cover: '',
        abstracts: '',
        type: '',
      },
    };
  },
  props: {
    fetchDetailApi: {
      type: Object,
      default: () => {},
    },
    detailId: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    isMp: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    icon() {
      return `${config.FILE_DOMAIN}images/shorcut/data.png`;
    },
  },
  methods: {
    getArticleDetail() {
      if (!this.detailId && !this.isMp) {
        this.detail = storage.local.get('article_info') || this.detail;
        return;
      }
      this.loading = true;
      const urlParams = `/${this.detail.id}`;
      sendRequest({
        ...this.fetchDetailApi,
        url: `${this.fetchDetailApi.url}${this.isMp ? '' : urlParams}`,
      }, {
        type: this.type,
        id: this.detailId,
      }).then((res) => {
        this.detail = res || {};
        // console.log(this.detail, res);
        // const {title = '', author = '', content = '', cover = '', abstracts = '', id = '', type} = res.data || {};
      }).catch((e) => {
        this.detail = {};
        console.log(e);
        // this.$dialog.alert({
        //   message: `${e.message}`,
        // });
      }).then(() => {
        this.$nextTick(() => {
          this.loading = false;
        });
      });
    },
    back() {
      this.$router.back();
      // this.$router.push('/home');
    },
  },
  created() {
    this.detail = {
      id: this.detailId,
    };
    this.getArticleDetail();
  },
  mounted() {
  },
  beforeDestroy() {
    storage.local.remove('article_info');
  },
};
</script>

<style scoped>
  .ArticleDetailCom {
    min-height: 100vh;
    background-color: #ffffff;
    font-size: 16px;
    padding: 10px;
  }
  input, select {
    min-height: 28px;
    width: 100%;
    font-size: 14px;
    border: 0;
    background-color: #ffffff;
  }
  textarea {
    border: 1px solid #f5f5f5;
    /* background-color: #f5f5f5; */
    width: 100%;
    min-height: 80px;
    padding: 8px;
  }
  img{
    object-fit: cover!important;
    width: 100%!important;
  }
  .article-content {
  }
</style>
